import React from 'react'
import { Card } from 'react-bootstrap'
import './CompanyCard.scss'
import placeholderImage from '../../assets/images/detailsPlaceholder.jpg'
import { Link, useNavigate } from 'react-router-dom'

export default function CompanyCard({ company }) {
  const navigate = useNavigate()

  let image = placeholderImage

  if (company?.cover_image) {
    image = company?.cover_image
  }

  return (
    <Link
      to={`/firma/${company.id}`}
      className="text-decoration-none text-dark">
      <Card className="shadow border-0 h-100 pointer company-card">
        <Card.Img src={image} alt={company.title} className="ms-2 my-2 me-0" />
        <Card.Body className="p-2">
          <h4 className="title">{company.name}</h4>

          <p className="desc">{company.description}</p>
        </Card.Body>
      </Card>
    </Link>
  )
}
